<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size"
    viewBox="0 0 24 24"><!-- Icon from BoxIcons by Atisa - https://creativecommons.org/licenses/by/4.0/ -->
    <path fill="currentColor" d="m10 15.586l-3.293-3.293l-1.414 1.414L10 18.414l9.707-9.707l-1.414-1.414z" />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'BxCheck',
  props: {
    size: {
      type: [Number, String],
      default: "1em",
    },
  },
}
</script>